import React, { useState, useEffect } from 'react'
import axios from 'axios';

import MamamonteChecks from "./MamamonteChecks";
import MamamonteResults from "./MamamonteResults";

const MamamonteTheme = ({varShowTheme,setShowTheme,varThemeInfo,setThemeInfo,GetMamamonteThemeList}) => {

  const [varMamamonteCheckList,setMamamonteCheckList] = useState([]);
  const [varMamamonteResultList,setMamamonteResultList] = useState([]);

  //마마몽떼 목록 읽어오기
  const GetMamamonteOptionsList = async () => {
    console.log('load...');
    const sendData = {vts_idx:varThemeInfo.vts_idx};
    await axios.post(`${process.env.REACT_APP_HOST}/_get_mamamonte_option_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setMamamonteCheckList(datas.checks);
        setMamamonteResultList(datas.results);
      }
    });
  }

  useEffect(() => {
    if(varThemeInfo.vts_idx > 0) GetMamamonteOptionsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varThemeInfo]);

  //입력값 조정
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "vts_index") {
      setThemeInfo({...varThemeInfo,[name]:Number(value)});
    } else {
      setThemeInfo({...varThemeInfo,[name]:value});
    }
  }

  //평가항목 저장
  const onUpdateThemeHandler = async(e) => {
    const sendData = {dataInfo:varThemeInfo};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_mamamonte_theme`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        GetMamamonteThemeList();
      } else {
        alert(res.data.message);
      }
    }); 
  }

  return (
    <div style={varShowTheme?{display:""}:{display:"none"}} >
      <div className="main-box">
        <table cellPadding="5" cellSpacing="0" border="1" className="write">
          <colgroup><col width="30%"/><col width="70%"/></colgroup>
          <thead></thead>
          <tbody>
            <tr>
              <th>고유번호</th>
              <td><input type="text" className="w_s_input" name="vts_index" value={varThemeInfo.vts_index||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
            <tr>
              <th>평가항목</th>
              <td><input type="text" className="w_s_input" name="vts_name" value={varThemeInfo.vts_name||""} onChange={(e)=>onChangeInputHandler(e)}/></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn-center" style={{marginBottom:"20px"}}>
        <button onClick={(e)=>onUpdateThemeHandler(e)} style={{width:"90px"}} className="btn">저장</button>
        <button onClick={()=>setShowTheme(false)} style={{width:"90px"}} className="btn line">닫기</button>
      </div>
       {/* 점검항목/결과 */}
      {varThemeInfo.vts_idx === 0?null:
        <>
        <MamamonteChecks varVTSIndex={varThemeInfo.vts_idx} varMamamonteCheckList={varMamamonteCheckList} GetMamamonteOptionsList={GetMamamonteOptionsList}/>
        <MamamonteResults varVTSIndex={varThemeInfo.vts_idx} varMamamonteResultList={varMamamonteResultList} GetMamamonteOptionsList={GetMamamonteOptionsList}/>
        </>
      }
    </div>
  )
}
export default MamamonteTheme;